interface MetaTag {
  name: string
  content: string
}

const META_TAGS: MetaTag[] = [
  { name: 'facebook-domain-verification', content: 'vlgvuhfbincjf8k22klsbsto3ag0az' },
]

/**
 * Inserts global <meta> tags into <head> once, for every route.
 * Existing tags with the same name are never duplicated.
 */
export function initHeadMeta(): void {
  if (typeof document === 'undefined') return

  META_TAGS.forEach(({ name, content }) => {
    if (document.querySelector(`meta[name="${name}"]`)) return

    const meta = document.createElement('meta')
    meta.name = name
    meta.content = content
    document.head.appendChild(meta)
  })
}
